const fr = {
  lang: 'fr', dir: 'ltr', flag: '🇫🇷', label: 'Français',

  nav: {
    home: 'Annonces', map: 'Carte', tools: 'Outils',
    messages: 'Messages', profile: 'Mon profil', admin: 'Admin',
    login: 'Connexion', register: 'Inscription', logout: 'Déconnexion',
    publish: '+ Publier',
  },

  search: {
    title: 'Trouver votre bien idéal',
    subtitle: 'Affinez votre recherche parmi nos annonces vérifiées',
    wilaya: 'Wilaya', commune: 'Commune', type: 'Type de bien',
    priceMin: 'Prix min (DZD)', priceMax: 'Prix max (DZD)',
    btn: 'Rechercher', reset: 'Réinitialiser',
    results: n => `${n} annonce${n > 1 ? 's' : ''} disponible${n > 1 ? 's' : ''}`,
    verified: 'Résultats vérifiés',
    allWilayas: '— Toutes les wilayas —',
    chooseWilayaFirst: '— Choisir une wilaya d\'abord —',
    allTypes: '— Tous les types —',
  },

  annonce: {
    types: {
      appartement: 'Appartement', villa: 'Villa', studio: 'Studio',
      bureau: 'Bureau', local: 'Local commercial', terrain: 'Terrain',
      ferme: 'Ferme', maison: 'Maison', duplex: 'Duplex',
    },
    surface: 'm²', rooms: 'ch.', bathrooms: 'SDB',
    seeDetails: 'Voir les détails',
    compare: 'Comparer', selected: 'Sélectionné',
    new: 'Nouveau', verified: 'Vérifié',
    addFav: 'Ajouter aux favoris', removeFav: 'Retirer des favoris',
    back: '← Retour',
    contact: 'Contacter le vendeur',
    call: 'Appeler', whatsapp: 'WhatsApp', email: 'E-mail',
    message: 'Message via Darna Immo',
    share: 'Partager', similar: 'Annonces similaires',
    guide: 'Guide d\'acquisition',
    delete: 'Supprimer l\'annonce',
    priceM2: 'DA/m²',
    negotiable: 'Négociable',
    floor: 'Étage',
    interested: 'personnes intéressées',
  },

  tools: {
    title: 'Outils gratuits',
    subtitle: 'Des outils pour vous aider dans votre projet immobilier',
    calcTitle: 'Calculateur Hypothèque',
    calcDesc: 'Estimez vos mensualités avec les taux des banques algériennes.',
    estimTitle: 'Estimateur de Valeur',
    estimDesc: 'Estimez la valeur de votre bien selon le quartier et la surface.',
    comparTitle: 'Comparateur Quartiers',
    comparDesc: 'Comparez les prix et tendances entre les quartiers.',
    calculate: 'Calculer →', estimate: 'Estimer →', compare: 'Comparer →',

    // Calculateur
    price: 'Prix du bien (DA)', downPayment: 'Apport personnel (DA)',
    duration: 'Durée (années)', rate: 'Taux d\'intérêt',
    calcBtn: 'Calculer', resetBtn: 'Réinitialiser',
    monthly: 'Mensualité', totalCost: 'Coût total', totalInterest: 'Total intérêts',
    amortTable: 'Tableau d\'amortissement',
    month: 'Mois', principal: 'Capital', interest: 'Intérêts',
    balance: 'Capital restant',

    // Estimateur
    wilaya: 'Wilaya', commune: 'Commune/Quartier', surfaceM2: 'Surface (m²)',
    typeLogement: 'Type de logement', etage: 'Étage',
    estimBtn: 'Estimer la valeur', estimLoading: 'Estimation…',
    estimResult: 'Valeur estimée', estimLow: 'Fourchette basse',
    estimHigh: 'Fourchette haute', estimPriceM2: 'Prix/m² moyen',
    backToTools: '← Outils',
    quartierLabel: 'Quartier', selectQuartier: 'Sélectionnez un quartier',
    allTypesOption: 'Tous types', roomsLabel: 'Chambres',
    estimError: 'Erreur lors de l\'estimation',
    estimFor: 'Estimation pour',
    confHigh: 'Fiabilité haute', confMid: 'Fiabilité moyenne',
    confLow: 'Fiabilité faible', confNone: 'Données insuffisantes',
    estimatedValue: 'Valeur estimée',
    avgPrice: 'Prix moyen', avgPriceM2: 'Prix moyen / m²',
    avgSurface: 'Surface moyenne', comparables: 'Annonces comparables',
    minPrice: 'Prix minimum', maxPrice: 'Prix maximum',
    toolsDisclaimer: 'Estimation basée sur les annonces publiées sur Darna Immo. Ne constitue pas une évaluation officielle.',
    addDistrict: '+ Ajouter', availableTypes: 'Types disponibles',
    nbAnnonces: 'Nombre d\'annonces',
    compareBtn: 'Comparer', comparLoading: 'Comparaison…',
    comparError: 'Erreur lors de la comparaison',
  },

  auth: {
    loginTitle: 'Connexion', registerTitle: 'Créer un compte',
    email: 'E-mail', phone: 'Téléphone', password: 'Mot de passe',
    name: 'Nom complet', firstName: 'Prénom', lastName: 'Nom',
    loginBtn: 'Se connecter', registerBtn: 'S\'inscrire',
    noAccount: 'Pas encore de compte ?', haveAccount: 'Déjà un compte ?',
    forgotPassword: 'Mot de passe oublié ?',
    orLogin: 'ou',
    loginSubtitle: 'Connectez-vous à votre compte Darna Immo',
    registerSubtitle: 'Rejoignez Darna Immo et trouvez votre bien idéal',
    locked: 'Compte temporairement verrouillé',
    lockedMsg: 'Trop de tentatives. Réessayez dans',
    loginLoading: 'Connexion…', registerLoading: 'Inscription…',
    lockedBtn: '🔒 Verrouillé',
    confirmPwd: 'Confirmer',
    pwdNoMatch: 'Les mots de passe ne correspondent pas',
    pwdTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
    connSuccess: 'Connexion réussie !', regSuccess: 'Inscription réussie !',
    createAccount: 'Créer un compte', connect: 'Se connecter',
  },

  profile: {
    title: 'Mon profil', myAnnonces: 'Mes annonces',
    stats: 'Statistiques', views: 'Vues', contacts: 'Contacts',
    favorites: 'Favoris', published: 'Annonces publiées',
    editProfile: 'Modifier le profil', save: 'Enregistrer',
    noAnnonces: 'Vous n\'avez pas encore d\'annonces.',
    loading: 'Chargement du profil…',
    personalInfo: 'Informations personnelles',
    phoneNotSet: 'Non renseigné', phoneVerified: '(vérifié)',
    annoncesPub: 'Annonces publiées', memberSince: 'Membre depuis',
    verifyPhone: 'Vérifier téléphone',
    statsSection: 'Statistiques de vos annonces',
    totalViews: 'Vues totales', contactsReceived: 'Contacts reçus',
    inFavorites: 'Mis en favoris', per30d: '/ 30j',
    annonceCol: 'Annonce', priceCol: 'Prix',
    statsEmpty: 'Aucune annonce publiée pour le moment.',
    saveBtn: 'Sauvegarder',
  },

  messages: {
    title: 'Messagerie', noConv: 'Aucune conversation',
    send: 'Envoyer', placeholder: 'Écrivez votre message… (Entrée pour envoyer)',
    you: 'Vous',
    exchanges: 'Vos échanges avec les acheteurs et vendeurs',
    selectConv: 'Sélectionnez une conversation',
    yesterday: 'Hier',
    disclaimer: 'Ne communiquez jamais vos coordonnées bancaires. Privilégiez les rendez-vous en lieu public pour les visites.',
  },

  common: {
    loading: 'Chargement…', error: 'Une erreur est survenue',
    save: 'Enregistrer', cancel: 'Annuler', delete: 'Supprimer',
    edit: 'Modifier', yes: 'Oui', no: 'Non', confirm: 'Confirmer',
    close: 'Fermer', seeAll: 'Voir tout', noResult: 'Aucun résultat',
    DA: 'DA', m2: 'm²',
  },

  carte: {
    title: 'Carte d\'Alger',
    subtitle: n => `Explorez les ${n} quartiers et découvrez les commodités`,
    accessible: 'Accessible',
    moyen: 'Moyen',
    premium: 'Premium',
    poisLabel: 'POIs',
    scoresTitle: 'Scores du quartier',
    marketTitle: 'Marché immobilier',
    amenities: 'Commodités',
    propertyTypes: 'Types de biens',
    listings: 'Annonces',
    seeListings: q => `Voir les annonces à ${q}`,
    estimateBtn: 'Estimer un bien',
    poi: {
      ecole: 'Éducation', mosquee: 'Mosquées', transport: 'Transport',
      commerce: 'Commerces', sante: 'Santé', parc: 'Espaces verts',
    },
    score: {
      transport: 'Transport', securite: 'Sécurité',
      education: 'Éducation', commerces: 'Commerces',
    },
  },

  create: {
    title: 'Publier une annonce',
    submit: 'Publier l\'annonce', cancel: 'Annuler',
    titleField: 'Titre', description: 'Description',
    type: 'Type de bien', prix: 'Prix (DA)', surface: 'Surface (m²)',
    rooms: 'Chambres', floor: 'Étage', photos: 'Photos',
    video: 'Vidéo', docs: 'Documents requis',
    back: 'Retour',
    subtitle: 'Remplissez les informations ci-dessous pour mettre votre bien en ligne.',
    progress: 'Progression',
    basicInfo: 'Informations de base',
    titleLabel: 'Titre de l\'annonce',
    titlePlaceholder: 'Ex : Belle villa avec jardin à Hydra',
    descPlaceholder: 'Décrivez votre bien : état, étage, orientation, commodités à proximité…',
    typeLabel: 'Type de logement',
    location: 'Localisation',
    selectWilaya: 'Sélectionner une wilaya',
    selectCommune: 'Sélectionner une commune',
    chooseWilayaFirst: '— Choisir la wilaya d\'abord —',
    priceAndSize: 'Prix et dimensions',
    priceLabel: 'Prix (DZD)',
    pricePlaceholder: 'Ex : 50 000 000',
    surfaceLabel: 'Surface (m²)',
    roomsLabel: 'Chambres',
    bathLabel: 'Salles d\'eau',
    mediaSection: 'Photos & Vidéos',
    mediaNote: 'Ajoutez jusqu\'à 10 photos et une vidéo de présentation. Les annonces avec photos reçoivent 5× plus de contacts.',
    addPhotos: 'Cliquez pour ajouter des photos',
    photoHint: 'JPG, PNG, WEBP · max 10 photos · 5 MB chacune',
    mainPhoto: 'Principale',
    videoLabel: 'Vidéo de présentation',
    optionalLabel: '(optionnel)',
    addVideo: 'Cliquez pour ajouter une vidéo',
    videoHint: 'MP4, MOV · max 100 MB · 3 minutes',
    contactSection: 'Coordonnées de contact',
    contactNote: 'Vos coordonnées seront visibles par les acheteurs potentiels.',
    phoneLabel: 'Téléphone',
    emailLabel: 'Email',
    docsSection: 'Documents & Confirmation',
    docsNote: 'Avant de publier, confirmez que vous disposez des documents nécessaires et que les informations sont exactes.',
    docsLegal: 'Toute annonce frauduleuse ou mensongère entraîne la suspension immédiate du compte et peut engager la responsabilité légale du vendeur.',
    submitting: 'Publication en cours…',
    trustNote: 'Votre annonce sera vérifiée par notre équipe avant publication.',
    errorCreating: 'Erreur lors de la création de l\'annonce',
    docsChecklist: [
      'J\'ai l\'acte de propriété ou le titre foncier',
      'La pièce d\'identité du vendeur est prête',
      'Le relevé cadastral est disponible',
      'Le prix indiqué reflète le prix réel de vente',
      'Les informations publiées sont exactes et à jour',
    ],
  },
};
export default fr;
